export default __webpack_public_path__ + "static/mall-304ef7488a4cd31427475bf6a0df200d.jpg";